import { List, Map } from 'immutable';

import { TYPES } from './actions';
import { SESSION_DESTROY } from '../../actions';
import Logger from '../../../lib/Logger';

const initialState = Map({
  isLoading: false,
  totalModuleSeriesAdmin: 0,
  totalModulesAdmin: 0,
  isLoadingIds: false,
  ids: List([]),
  moduleDetailIsVisible: false,
  moduleDetailModuleId: null,
  moduleSerieDetailIsVisible: false,
});

export default function learningsAdmin(state = initialState, action) {
  Logger.log(
    'debug',
    `[state.learningsAdmin.reducers] learningsAdmin(%j, %j)`,
    state,
    action
  );

  switch (action.type) {
    case TYPES.MODULE_SERIE_ADMIN_LIST_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case TYPES.MODULE_SERIE_ADMIN_LIST_SUCCESS:
      return state
        .mergeDeep({
          isLoading: false,
          moduleSeriesAdmin: {
            [action.scope]: {
              [action.partnershipId]: {
                [action.action]: {
                  pages: {
                    [action.order]: {
                      [action.limit]: {
                        [action.page]: null,
                      },
                    },
                  },
                  lastUpdated: action.receivedAt,
                  totalModuleSeriesAdmin: action.total,
                },
              },
            },
          },
        })
        .setIn(
          [
            'moduleSeriesAdmin',
            action.scope,
            action.partnershipId,
            action.action,
            'pages',
            action.order,
            action.limit,
            action.page,
          ],
          List(action.result)
        );

    case TYPES.MODULE_SERIE_ADMIN_LIST_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case TYPES.MODULE_SERIE_ADMIN_CREATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null,
        },
      });

    case TYPES.MODULE_SERIE_ADMIN_CREATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          created_id: action.id,
          errors: null,
        },
        lastUpdated: action.receivedAt,
      });

    case TYPES.MODULE_SERIE_ADMIN_CREATE_FAILURE:
      return state
        .mergeDeep({
          isLoading: false,
          form: {
            isSubmitting: false,
            success: false,
            errors: null,
          },
        })
        .setIn(['form', 'errors'], action.error);

    case TYPES.MODULE_SERIE_ADMIN_UPDATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null,
        },
      });

    case TYPES.MODULE_SERIE_ADMIN_UPDATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          errors: null,
        },
        lastUpdated: action.receivedAt,
      });

    case TYPES.MODULE_SERIE_ADMIN_UPDATE_FAILURE:
      return state
        .mergeDeep({
          isLoading: false,
          form: {
            isSubmitting: false,
            success: false,
            errors: null,
          },
        })
        .setIn(['form', 'errors'], action.error);

    case TYPES.MODULE_SERIE_ADMIN_READ_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case TYPES.MODULE_SERIE_ADMIN_READ_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt,
      });

    case TYPES.MODULE_SERIE_ADMIN_READ_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case TYPES.MODULE_SERIE_ADMIN_PATCH_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null,
        },
      });

    case TYPES.MODULE_SERIE_ADMIN_PATCH_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          errors: null,
        },
        lastUpdated: action.receivedAt,
      });

    case TYPES.MODULE_SERIE_ADMIN_PATCH_FAILURE:
      return state
        .mergeDeep({
          isLoading: false,
          form: {
            isSubmitting: false,
            success: false,
            errors: null,
          },
        })
        .setIn(['form', 'errors'], action.error);

    case TYPES.MODULE_SERIE_ADMIN_IDS_REQUEST:
      return state.mergeDeep({
        isLoadingIds: true,
      });

    case TYPES.MODULE_SERIE_ADMIN_IDS_SUCCESS:
      return state
        .mergeDeep({
          isLoadingIds: false,
        })
        .setIn(['ids'], List(action.data));

    case TYPES.MODULE_SERIE_ADMIN_IDS_FAILURE:
      return state.mergeDeep({
        isLoadingIds: false,
      });

    case TYPES.MODULE_SERIE_ADMIN_DELETE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt,
      });

    case TYPES.MODULE_SERIE_ADMIN_DELETE_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case TYPES.MODULE_SERIE_ADMIN_DELETES_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case TYPES.MODULE_SERIE_ADMIN_DELETES_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt,
      });

    case TYPES.MODULE_SERIE_ADMIN_DELETES_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case TYPES.MODULE_ADMIN_LIST_BY_MODULE_SERIE_ID_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case TYPES.MODULE_ADMIN_LIST_BY_MODULE_SERIE_ID_SUCCESS:
      return state
        .mergeDeep({
          isLoading: false,
          modulesAdmin: {
            [action.scope]: {
              [action.partnershipId]: {
                [action.moduleSerieId]: {
                  pages: {
                    [action.order]: {
                      [action.limit]: {
                        [action.page]: null,
                      },
                    },
                  },
                  lastUpdated: action.receivedAt,
                  totalModulesAdmin: action.total,
                },
              },
            },
          },
        })
        .setIn(
          [
            'modulesAdmin',
            action.scope,
            action.partnershipId,
            action.moduleSerieId,
            'pages',
            action.order,
            action.limit,
            action.page,
          ],
          List(action.result)
        );

    case TYPES.MODULE_ADMIN_LIST_BY_MODULE_SERIE_ID_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case TYPES.MODULE_ADMIN_LIST_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case TYPES.MODULE_SERIE_ADMIN_FORM_DESTROY:
      return state
        .mergeDeep({
          form: null,
        })
        .set('form', action.form);

    case TYPES.MODULE_ADMIN_FORM_DESTROY:
      return state
        .mergeDeep({
          form: null,
        })
        .set('form', action.form);

    case TYPES.MODULE_ADMIN_LIST_SUCCESS:
      return state
        .mergeDeep({
          isLoading: false,
          modulesAdmin: {
            [action.scope]: {
              [action.partnershipId]: {
                pages: {
                  [action.order]: {
                    [action.limit]: {
                      [action.page]: null,
                    },
                  },
                },
                lastUpdated: action.receivedAt,
                totalModulesAdmin: action.total,
              },
            },
          },
        })
        .setIn(
          [
            'modulesAdmin',
            action.scope,
            action.partnershipId,
            'pages',
            action.order,
            action.limit,
            action.page,
          ],
          List(action.result)
        );

    case TYPES.MODULE_ADMIN_LIST_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case TYPES.MODULE_ADMIN_PATCH_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null,
        },
      });

    case TYPES.MODULE_ADMIN_PATCH_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          errors: null,
        },
        lastUpdated: action.receivedAt,
      });

    case TYPES.MODULE_ADMIN_PATCH_FAILURE:
      return state
        .mergeDeep({
          isLoading: false,
          form: {
            isSubmitting: false,
            success: false,
            errors: null,
          },
        })
        .setIn(['form', 'errors'], action.error);

    case TYPES.MODULE_ADMIN_IDS_REQUEST:
      return state.mergeDeep({
        isLoadingIds: true,
      });

    case TYPES.MODULE_ADMIN_IDS_SUCCESS:
      return state
        .mergeDeep({
          isLoadingIds: false,
        })
        .setIn(['ids'], List(action.data));

    case TYPES.MODULE_ADMIN_IDS_FAILURE:
      return state.mergeDeep({
        isLoadingIds: false,
      });

    case TYPES.MODULE_ADMIN_DELETE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt,
      });

    case TYPES.MODULE_ADMIN_DELETE_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case TYPES.MODULE_ADMIN_DELETES_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case TYPES.MODULE_ADMIN_DELETES_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt,
      });

    case TYPES.MODULE_ADMIN_DELETES_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });
    case TYPES.MODULE_CATEGORY_ADMIN_LIST_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case TYPES.MODULE_CATEGORY_ADMIN_LIST_SUCCESS:
      return state
        .mergeDeep({
          isLoading: false,
          moduleCategoriesAdmin: {
            [action.partnershipId]: {
              pages: {
                [action.order]: {
                  [action.limit]: {
                    [action.page]: null,
                  },
                },
              },
              lastUpdated: action.receivedAt,
              totalModuleCategoriesAdmin: action.total,
            },
          },
        })
        .setIn(
          [
            'moduleCategoriesAdmin',
            action.partnershipId,
            'pages',
            action.order,
            action.limit,
            action.page,
          ],
          List(action.result)
        );

    case TYPES.MODULE_CATEGORY_ADMIN_LIST_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case TYPES.MODULE_CATEGORY_ADMIN_DELETE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt,
      });

    case TYPES.MODULE_CATEGORY_ADMIN_DELETE_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case TYPES.MODULE_CATEGORY_ADMIN_CREATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null,
        },
      });

    case TYPES.MODULE_CATEGORY_ADMIN_CREATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          errors: null,
        },
        lastUpdated: action.receivedAt,
      });

    case TYPES.MODULE_CATEGORY_ADMIN_CREATE_FAILURE:
      return state
        .mergeDeep({
          isLoading: false,
          form: {
            isSubmitting: false,
            success: false,
            errors: null,
          },
        })
        .setIn(['form', 'errors'], action.error);

    case TYPES.MODULES_ADMIN_CREATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null,
        },
      });

    case TYPES.MODULES_ADMIN_CREATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          created_id: action.id,
          errors: null,
        },
        lastUpdated: action.receivedAt,
      });

    case TYPES.MODULES_ADMIN_CREATE_FAILURE:
      return state
        .mergeDeep({
          isLoading: false,
          form: {
            isSubmitting: false,
            success: false,
            errors: null,
          },
        })
        .setIn(['form', 'errors'], action.error);

    case TYPES.MODULES_ADMIN_UPDATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null,
        },
      });

    case TYPES.MODULES_ADMIN_UPDATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          created_id: action.id,
          errors: null,
        },
        lastUpdated: action.receivedAt,
      });

    case TYPES.MODULES_ADMIN_UPDATE_FAILURE:
      return state
        .mergeDeep({
          isLoading: false,
          form: {
            isSubmitting: false,
            success: false,
            errors: null,
          },
        })
        .setIn(['form', 'errors'], action.error);

    case TYPES.MODULE_ADMIN_CREATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null,
        },
      });

    case TYPES.MODULE_ADMIN_CREATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          created_id: action.id,
          errors: null,
        },
        lastUpdated: action.receivedAt,
      });

    case TYPES.MODULE_ADMIN_CREATE_FAILURE:
      return state
        .mergeDeep({
          isLoading: false,
          form: {
            isSubmitting: false,
            success: false,
            errors: null,
          },
        })
        .setIn(['form', 'errors'], action.error);

    case TYPES.MODULE_ADMIN_READ_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case TYPES.MODULE_ADMIN_READ_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt,
      });

    case TYPES.MODULE_ADMIN_READ_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case TYPES.MODULE_ADMIN_UPDATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null,
        },
      });

    case TYPES.MODULE_ADMIN_UPDATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          errors: null,
        },
        lastUpdated: action.receivedAt,
      });

    case TYPES.MODULE_ADMIN_UPDATE_FAILURE:
      return state
        .mergeDeep({
          isLoading: false,
          form: {
            isSubmitting: false,
            success: false,
            errors: null,
          },
        })
        .setIn(['form', 'errors'], action.error);

    case TYPES.MODULE_ADMIN_SHOW_PREVIEW_DETAIL:
      return state.mergeDeep({
        moduleDetailIsVisible: true,
        moduleDetailModuleId: action.moduleId,
      });

    case TYPES.MODULE_ADMIN_HIDE_PREVIEW_DETAIL:
      return state.mergeDeep({
        moduleDetailIsVisible: false,
        moduleDetailModuleId: null,
      });

    case TYPES.MODULE_SERIE_ADMIN_LIST_SHOW_PREVIEW_DETAIL:
      return state.mergeDeep({
        moduleSerieDetailIsVisible: true,
      });

    case TYPES.MODULE_SERIE_ADMIN_LIST_HIDE_PREVIEW_DETAIL:
      return state.mergeDeep({
        moduleSerieDetailIsVisible: false,
      });

    case SESSION_DESTROY:
      return initialState;

    default:
      return state;
  }
}

Logger.log('silly', `state.learningsAdmin.reducers loaded.`);
